module.exports = __webpack_public_path__ + "static/img/light-blue.ba444c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light-blue.png
// module id = Ar4C
// module chunks = 1